import React from 'react';

export const ChatMessage = ({ role, text }) => {
  return (
    <div className={`cmsg ${role === "user" ? "user" : "bot"}`}>
      {text}
    </div>
  );
};